import { render, staticRenderFns } from "./ViewBook.vue?vue&type=template&id=2bd33fa0"
import script from "./ViewBook.vue?vue&type=script&lang=js"
export * from "./ViewBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports